"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDetailHeaderBoxOffset = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const andes_react_1 = require("@yonderland/andes-react");
const HtmlInclude_1 = require("../common/html-include/HtmlInclude");
const BOX_ID = 'header-box-offset';
const ContentDetailHeaderBoxOffset = ({ children }) => {
    const getStyleFragment = () => `
    @media (min-width: ${andes_react_1.screens['2xl']}) {
        #${BOX_ID} {
            padding-left: calc((100vw - 1336px) / 2);
        }
    }
    @media (min-width: ${andes_react_1.screens['3xl']}) {
        #${BOX_ID} {
            padding-left: 292px;
        }
    }
  `;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HtmlInclude_1.HtmlInclude, { styleFragment: getStyleFragment() }), (0, jsx_runtime_1.jsx)("div", { id: BOX_ID, children: children })] }));
};
exports.ContentDetailHeaderBoxOffset = ContentDetailHeaderBoxOffset;
